module.exports = __webpack_public_path__ + "img/10.82e7c42e.png";